(function (){
  'use strict';

  angular.module('ringbaPortal').directive('plusPrefixInNumber', plusPrefixInNumber);

  function plusPrefixInNumber () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, controller) {
        controller.$formatters.push(ensurePlusPrefix);
        controller.$parsers.splice(0, 0, ensurePlusPrefix);

        function ensurePlusPrefix(value) {
          if (value.charAt(0) !== '+') {
            value = value.substr(1);
          }
          
          if((value && !/^\+/.test(value) && '+'.indexOf(value) !== 0) || value === '' ) {
            controller.$setViewValue('+' + value);
            controller.$render();
            return '+' + value;
          } else {
            controller.$setViewValue(value);
            controller.$render();
            return value;
          }
        }
      }
    };
  }
})();
